export default (value: number) => {
    if (value >= 1e9) return Math.round(value / 1e9) + 'B';
    if (value >= 1e6) return Math.round(value / 1e6) + 'M';
    if (value >= 1e3) return Math.round(value / 1e3) + 'K';
    return value;
  };
